/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-lines */
import LockIcon from '@scandipwa/scandipwa/src/component/LockIcon';

import Button from 'Component/Button';
import {
    SIZE_NONE,
    TYPE_TEXT, WIDTH_FIXED, WIDTH_HUG
}
from 'Component/Button/Button.config';
import CartItem from 'Component/CartItem';
import CrossIcon from 'Component/CrossIcon';
import FreeShippingNotificationComponent from 'Component/FreeShippingNotification';
import { CART_OVERLAY } from 'Component/Header/Header.config';
import {
    BLACK_KEY, GREY500_KEY, M_KEY, S_KEY
} from 'Component/Icon/Icon.config';
import Loader from 'Component/Loader';
import Overlay from 'Component/Overlay';
import { OVERLAY_PLACEHOLDER } from 'Component/PopupSuspense/PopupSuspense.config';
import {
    CartOverlay as SourceCartOverlay
} from 'SourceComponent/CartOverlay/CartOverlay.component';
import { scrollToTop } from 'Util/Browser';
import { formatPrice } from 'Util/Price';

import { TYPE_PRIMARY, TYPE_TERTIARY } from '../Button/Button.config';
import WarningIconComponent from '../WarningIcon';

import './CartOverlay.style';

/** @namespace Bodypwa/Component/CartOverlay/Component */
export class CartOverlayComponent extends SourceCartOverlay {
    // eslint-disable-next-line @scandipwa/scandipwa-guidelines/only-render-in-component
    componentDidMount() {
        const { showOverlay, isMobile, activeOverlay } = this.props;

        if (!isMobile && activeOverlay === OVERLAY_PLACEHOLDER) {
            showOverlay(CART_OVERLAY);
        }
    }

    renderShipping() {
        const {
            totals: {
                shipping_amount
            } = {}
        } = this.props;

        return (
            <dl
              block="CartOverlay"
              elem="Shipping"
            >
                <dt>{ __('Shipping:') }</dt>
                <dd>{ this.renderPriceLine(shipping_amount) }</dd>
            </dl>
        );
    }

    renderCartAdditional() {
        const { totals: { items = [] } } = this.props;

        if (items.length < 1) {
            return null;
        }

        return (
            <div block="CartOverlay" elem="Additional">
                { this.renderDiscount() }
                { this.renderShipping() }
                { this.renderTotals() }
                { this.renderOutOfStockProductsWarning() }
                { this.renderActions() }
            </div>
        );
    }

    renderHeading() {
        const { totals: { items_qty }, hideOverlay } = this.props;
        const label = items_qty === 1 ? __('%s item', items_qty) : __('%s items', items_qty);

        return (
            <div block="CartOverlay" elem="Heading-Container">
                <div block="CartOverlay" elem="Heading">
                    <h1>
                        { __('My Cart') }
                        &nbsp;
                        { /* eslint-disable-next-line @scandipwa/scandipwa-guidelines/jsx-no-conditional */ }
                        { items_qty > 0 ? (
                        <span>
                            { label }
                        </span>
                        ) : '' }
                    </h1>
                    <Button
                      onClick={ hideOverlay }
                      isIcon
                      type={ TYPE_TEXT }
                      width={ WIDTH_HUG }
                      size={ SIZE_NONE }
                    >
                        <CrossIcon size={ M_KEY } color={ BLACK_KEY } />
                    </Button>
                </div>
                { this.renderFreeShippingNotification() }
            </div>
        );
    }

    renderOutOfStockProductsWarning() {
        const { hasOutOfStockProductsInCart } = this.props;

        if (!hasOutOfStockProductsInCart) {
            return null;
        }

        return (
            <div block="CartOverlay" elem="OutOfStockProductsWarning">
                <WarningIconComponent />
                { __('Please, remove out of stock products from cart') }
            </div>
        );
    }

    renderSecureCheckoutButton() {
        const { handleCheckoutClick } = this.props;

        return (
            <Button
              type={ TYPE_PRIMARY }
              width={ WIDTH_FIXED }
              isIcon
              onClick={ handleCheckoutClick }
              text={ __('Checkout') }
            >
                <LockIcon size={ S_KEY } color={ BLACK_KEY } />

            </Button>
        );
    }

    renderNoCartItems() {
        return (
            <p block="CartOverlay" elem="Empty">
                <LockIcon size="m" color={ GREY500_KEY } />
                { __('You have no items in your shopping cart.') }
            </p>
        );
    }

    renderTotals() {
        const { totals: { grand_total = 0, tax_amount } } = this.props;
        const taxLabel = tax_amount ? __('(Incl. Tax)') : __('(Excl. Tax)');
        return (
            <dl
              block="CartOverlay"
              elem="Total"
            >
                <dt>
                    { __('Total') }
                    <span>{ taxLabel }</span>
                </dt>
                <dd>
                    { this.renderPriceLine(grand_total) }
                    { this.renderOrderTotalExlTax() }
                </dd>
            </dl>
        );
    }

    renderFreeShippingNotification() {
        const { totals: { items = [] } } = this.props;

        if (items.length < 1) {
            return null;
        }

        return (
            <div
              block="CartOverlay"
              elem="FreeShippingNotification"
            >
                <FreeShippingNotificationComponent />
            </div>
        );
    }

    renderPriceLine(price) {
        const { currencyCode } = this.props;

        if (!currencyCode) {
            return null;
        }

        return formatPrice(price, currencyCode);
    }

    renderCartItems() {
        const {
            totals: {
                items = [],
                quote_currency_code,
                items_qty
            },
            onCartItemLoading,
            loading
        } = this.props;

        // eslint-disable-next-line no-constant-condition
        if (items_qty === -1) {
            return (
                <div block="CartOverlay" elem="Loader">
                    <Loader isLoading loaderTxt={ __('Content loading...') } />
                </div>
            );
        }

        if (items.length < 1) {
            return this.renderNoCartItems();
        }

        return (
            <>
                <Loader isLoading={ !!loading } />
                <div block="CartOverlay" elem="Items" aria-label="List of items in cart">
                    { items.map((item) => (
                        <CartItem
                          key={ item.item_id }
                          item={ item }
                          currency_code={ quote_currency_code }
                          onCartItemLoading={ onCartItemLoading }
                          showLoader={ false }
                          isCartOverlay
                        />
                    )) }
                </div>
            </>
        );
    }

    renderActions() {
        return (
            <div block="CartOverlay" elem="Actions">
                <Button
                  type={ TYPE_TERTIARY }
                  isLink
                  width={ WIDTH_HUG }
                  onClick={ scrollToTop }
                  goTo="/cart"
                  text={ __('View cart') }
                />
                { this.renderSecureCheckoutButton() }
            </div>
        );
    }

    render() {
        const { changeHeaderState, totals: { items_qty } = {}, cartHeight } = this.props;

        return (
            <Overlay
              id={ CART_OVERLAY }
              onVisible={ changeHeaderState }
              isFrezeScroll={ false }
              mix={ { block: 'CartOverlay', mods: { Loading: items_qty === -1 } } }
            >
                <div
                  block="CartOverlay"
                  elem="ContentWrapper"
                  style={ { maxHeight: cartHeight } }
                >
                    { this.renderHeading() }
                    { this.renderCartItems() }
                    { this.renderCartAdditional() }
                </div>
            </Overlay>
        );
    }
}

export default CartOverlayComponent;
